module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "updPassword"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yzm),
      expression: "yzm"
    }],
    staticClass: "yzm am-fl",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.yzm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yzm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "yzm am-fr",
    class: {
      disable: this.btnyzm !== '获取验证码'
    },
    on: {
      "click": function($event) {
        _vm.sendCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.btnyzm))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    attrs: {
      "type": "password",
      "placeholder": "再次输入新密码"
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-top": "-5px"
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('p', [_vm._v("放弃找回，"), _c('span', [_c('router-link', {
    staticClass: "first",
    attrs: {
      "to": {
        name: 'zcgl',
        params: {
          nr: 'login'
        }
      }
    }
  }, [_vm._v("返回登录页面")])], 1)])]), _vm._v(" "), _c('alert', {
    attrs: {
      "showModal": _vm.showAlert
    },
    on: {
      "update:showModal": function($event) {
        _vm.showAlert = $event
      }
    }
  }, [_vm._v(_vm._s(_vm.alertMessage))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('i', {
    staticClass: "iconfont icon-zhaohuimima1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-046fe29b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/zcgl/page/updPassword.vue
// module id = 859
// module chunks = 2